// extracted by mini-css-extract-plugin
export var externalLink = "_cp-0";
export var internalLinkLabel = "_cp-1";